/**
 * @generated SignedSource<<092cc60a0b947f24803403337b3d6bc2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventConnectionOrder = "CREATED_AT" | "ORDERING_PRIORITY";
export type EventConnectionSortDirection = "ASCENDING" | "DESCENDING";
export type EventStatus = "ACTIVE" | "CLOSED" | "UPCOMING";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
export type EventQueryFilters = {
  locations?: ReadonlyArray<LocationKind> | null | undefined;
  order?: EventConnectionOrder;
  rewards?: ReadonlyArray<RewardKind> | null | undefined;
  search?: string | null | undefined;
  sortDirection?: EventConnectionSortDirection;
  status?: EventStatus | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type ActivityScaffoldQuery$variables = {
  activeFilters?: EventQueryFilters | null | undefined;
  closedFilters?: EventQueryFilters | null | undefined;
  filters?: EventQueryFilters | null | undefined;
  search?: string | null | undefined;
  tutorialFilters?: EventQueryFilters | null | undefined;
  upcomingFilters?: EventQueryFilters | null | undefined;
};
export type ActivityScaffoldQuery$data = {
  readonly active: {
    readonly totalCount: number;
  };
  readonly closed: {
    readonly totalCount: number;
  };
  readonly competitions: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
    readonly totalCount: number;
  };
  readonly events: {
    readonly totalCount: number;
  };
  readonly tutorial: {
    readonly totalCount: number;
  };
  readonly upcoming: {
    readonly totalCount: number;
  };
  readonly viewer: {
    readonly events: {
      readonly totalCount: number;
    };
    readonly viewerCanCreateEvent: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EventFiltersFragment">;
};
export type ActivityScaffoldQuery = {
  response: ActivityScaffoldQuery$data;
  variables: ActivityScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeFilters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "closedFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tutorialFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "upcomingFilters"
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "kind": "ObjectValue",
      "name": "filters"
    },
    (v6/*:: as any*/)
  ],
  "concreteType": "CompetitionConnection",
  "kind": "LinkedField",
  "name": "competitions",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  (v7/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": [
    (v6/*:: as any*/)
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": "events(first:0)"
},
v11 = {
  "alias": "viewerCanCreateEvent",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_EVENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_EVENT\")"
},
v12 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v13 = [
  (v12/*:: as any*/),
  (v6/*:: as any*/)
],
v14 = {
  "alias": null,
  "args": (v13/*:: as any*/),
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": null
},
v15 = {
  "alias": "tutorial",
  "args": [
    {
      "kind": "Variable",
      "name": "filters",
      "variableName": "tutorialFilters"
    },
    (v6/*:: as any*/)
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": null
},
v16 = {
  "alias": "upcoming",
  "args": [
    {
      "kind": "Variable",
      "name": "filters",
      "variableName": "upcomingFilters"
    },
    (v6/*:: as any*/)
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": null
},
v17 = {
  "alias": "active",
  "args": [
    {
      "kind": "Variable",
      "name": "filters",
      "variableName": "activeFilters"
    },
    (v6/*:: as any*/)
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": null
},
v18 = {
  "alias": "closed",
  "args": [
    {
      "kind": "Variable",
      "name": "filters",
      "variableName": "closedFilters"
    },
    (v6/*:: as any*/)
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivityScaffoldQuery",
    "selections": [
      (v8/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*:: as any*/),
          (v11/*:: as any*/)
        ],
        "storageKey": null
      },
      (v14/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      {
        "args": [
          (v12/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "EventFiltersFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "ActivityScaffoldQuery",
    "selections": [
      (v8/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v19/*:: as any*/)
        ],
        "storageKey": null
      },
      (v14/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "activityKind",
                "value": "EVENT"
              }
            ],
            "kind": "ObjectValue",
            "name": "filters"
          }
        ],
        "concreteType": "TagConnection",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v19/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "tags(filters:{\"activityKind\":\"EVENT\"})"
      },
      {
        "alias": "eventCount",
        "args": (v13/*:: as any*/),
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v9/*:: as any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d68a6d4fcf78775170512796e9cdedf",
    "id": null,
    "metadata": {},
    "name": "ActivityScaffoldQuery",
    "operationKind": "query",
    "text": "query ActivityScaffoldQuery(\n  $search: String\n  $filters: EventQueryFilters\n  $tutorialFilters: EventQueryFilters\n  $upcomingFilters: EventQueryFilters\n  $activeFilters: EventQueryFilters\n  $closedFilters: EventQueryFilters\n) {\n  competitions(first: 0, filters: {search: $search}) {\n    totalCount\n    edges {\n      cursor\n    }\n  }\n  viewer @ifAllowed {\n    __typename\n    events(first: 0) {\n      totalCount\n    }\n    viewerCanCreateEvent: viewerCan(action: CREATE_EVENT)\n    id\n  }\n  events(first: 0, filters: $filters) {\n    totalCount\n  }\n  tutorial: events(first: 0, filters: $tutorialFilters) {\n    totalCount\n  }\n  upcoming: events(first: 0, filters: $upcomingFilters) {\n    totalCount\n  }\n  active: events(first: 0, filters: $activeFilters) {\n    totalCount\n  }\n  closed: events(first: 0, filters: $closedFilters) {\n    totalCount\n  }\n  ...EventFiltersFragment_VTAHT\n}\n\nfragment EventFiltersFragment_VTAHT on Query {\n  ...TagsFieldsFragment_3mhn6h\n  ...EventFiltersTotalCountFragment_VTAHT\n}\n\nfragment EventFiltersTotalCountFragment_VTAHT on Query {\n  eventCount: events(first: 0, filters: $filters) {\n    totalCount\n  }\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagsFieldsFragment_3mhn6h on Query {\n  tags(filters: {activityKind: EVENT}) {\n    nodes {\n      id\n      name\n      ...TagFragment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "42f33b25c1035e6c0e157d7372caadfb";

export default node;
